export default __webpack_public_path__ + "images/0x5deb27e51dbeef691ba1175a2e563870499c2acb.png";